export default __webpack_public_path__ + "static/media/undraw_notify_re_65on.ad6682e5.svg";